import React from 'react'
import PropTypes from 'prop-types'
import RefreshIndicator from 'material-ui/RefreshIndicator'
import Waypoint from 'react-waypoint'
import Header from './Header'
import { choosePhoneNumberFormatter } from '../../../services/formatters'
import List from './List'

import css from './styles.css'

const PatientListView = ({
  currentPage,
  fetchNextPage,
  handleSortThenFetchPatients,
  isTops,
  loading,
  patients,
  sortCol,
  sortDir,
  totalPages,
  totalPatients,
  userCountryCode,
}) => (
  <div className={css.wrapper}>

    <div className={css.loader}>
      <RefreshIndicator
        size={50}
        top={-15}
        left={0}
        status={loading ? 'loading' : 'hide'}
        color="#1B78B3"
      />
    </div>
    {
      !loading && currentPage === totalPages &&
      <div className={css.verticalLine} />
    }
    {
      patients.length < 1 && !loading ? (
        <div>
          <h2>No Results Found</h2>
          <h4>Change the selected filters to adjust your search criteria</h4>
        </div>
      ) : ([
        <div key="filtersTitle" className={css.filtersTitle}>Patients:</div>,
        <Header
          handleSortThenFetchPatients={handleSortThenFetchPatients}
          key="header"
          sortCol={sortCol}
          sortDir={sortDir}
        />,
        <List
          formatPhoneNumber={choosePhoneNumberFormatter(userCountryCode)}
          isTops={isTops}
          key="list"
          patients={patients}
          totalPatients={totalPatients}
        />,
      ])
    }
    <Waypoint onEnter={fetchNextPage} />
  </div>
)

PatientListView.propTypes = {
  currentPage: PropTypes.number.isRequired,
  fetchNextPage: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  patients: PropTypes.arrayOf(PropTypes.object).isRequired,
  sortCol: PropTypes.oneOf(['first_name', 'last_name', 'email', 'phone']).isRequired,
  sortDir: PropTypes.oneOf(['asc', 'desc']).isRequired,
  totalPages: PropTypes.number,
  userCountryCode: PropTypes.string.isRequired,
}

export default PatientListView



// WEBPACK FOOTER //
// ./src/components/PatientGroups/PatientList/View.js